import http from "@/plugins/axios_plugin";

const options = {
  responseType: "blob",
};

class ServiceRelatorios {
  // Administradores

  /* vendasAdm() {
        return http.get('/api/relatorios/vendas?tipousuario=adm')
    }

    vendasPorFornecedorAdm() {
        return http.get('/api/relatorios/vendas-por-fornecedor?tipousuario=adm')
    }

    vendasPorRepresentanteAdm() {
        return http.get('/api/relatorios/vendas-por-representante?tipousuario=adm')
    }

    vendasPorClienteAdm() {
        return http.get('/api/relatorios/vendas-por-cliente?tipousuario=adm')
    }

    vendasPorEstadoAdm() {
        return http.get('/api/relatorios/vendas-por-estado?tipousuario=adm')
    }

    vendasPorRegiaoAdm() {
        return http.get('/api/relatorios/vendas-por-regiao?tipousuario=adm')
    }

    // Fornecedores

    vendasFor(fornecedor) {
        return http.get('/api/relatorios/vendas?tipousuario=for&id=' + fornecedor)
    }

    vendasPorRepresentanteFor(fornecedor) {
        return http.get('/api/relatorios/vendas-por-representante?tipousuario=for&id=' + fornecedor)
    }

    vendasPorClienteFor(fornecedor) {
        return http.get('/api/relatorios/vendas-por-cliente?tipousuario=for&id=' + fornecedor)
    }

    vendasPorEstadoFor(fornecedor) {
        return http.get('/api/relatorios/vendas-por-estado?tipousuario=for&id=' + fornecedor)
    }

    vendasPorRegiaoFor(fornecedor) {
        return http.get('/api/relatorios/vendas-por-regiao?tipousuario=for&id=' + fornecedor)
    }

    produtosMaisVendidos(fornecedor) {
        return http.get('/api/relatorios/produtos-mais-vendidos?tipousuario=for&id=' + fornecedor)
    }

    // Representantes

    vendasRep(representante) {
        return http.get('/api/relatorios/vendas?tipousuario=rep&id=' + representante)
    }

    vendasPorFornecedorRep(representante) {
        return http.get('/api/relatorios/vendas-por-fornecedor?tipousuario=rep&id=' + representante)
    }

    vendasPorClienteRep(representante) {
        return http.get('/api/relatorios/vendas-por-cliente?tipousuario=rep&id=' + representante)
    }

    vendasPorEstadoRep(representante) {
        return http.get('/api/relatorios/vendas-por-estado?tipousuario=rep&id=' + representante)
    }

    vendasPorRegiaoRep(representante) {
        return http.get('/api/relatorios/vendas-por-regiao?tipousuario=rep&id=' + representante)
    } */

  getClientes(params) {
    return http.get("/api/relatorios/getclientes", { params });
  }

  getLojas(cliente_id) {
    return http.get("/api/relatorios/clientes/" + cliente_id + "/lojas/listar");
  }

  getRepresentantes() {
    return http.get("/api/relatorios/getrepresentantes");
  }

  getFornecedores() {
    return http.get("/api/relatorios/getfornecedores");
  }

  imprimirSomatorioPedidosPorCliente(params) {
    return http
      .get("/api/relatorios/pedidosporclientesoma", { ...options, params })
      .then((response) => response.data);
  }

  imprimirPedidosPorCliente(params) {
    return http
      .get("/api/relatorios/pedidosporcliente", { ...options, params })
      .then((response) => response.data);
  }

  imprimirSomatorioPedidosPorRepresentante(params) {
    return http
      .get("/api/relatorios/pedidosporrepresentantesoma", {
        ...options,
        params,
      })
      .then((response) => response.data);
  }

  imprimirPedidosPorRepresentante(params) {
    return http
      .get("/api/relatorios/pedidosporrepresentante", { ...options, params })
      .then((response) => response.data);
  }

  imprimirSomatorioPedidosPorFornecedor(params) {
    return http
      .get("/api/relatorios/pedidosporfornecedorsoma", { ...options, params })
      .then((response) => response.data);
  }

  imprimirPedidosPorFornecedor(params) {
    return http
      .get("/api/relatorios/pedidosporfornecedor", { ...options, params })
      .then((response) => response.data);
  }

  imprimirProdutosVendidos(params) {
    return http
      .get("/api/relatorios/produtosvendidos", { ...options, params })
      .then((response) => response.data);
  }

  imprimirProdutosConsolidado(params) {
    return http
      .get("/api/relatorios/produtosconsolidado", { ...options, params })
      .then((response) => response.data);
  }

  imprimirPedidosPorClienteArquivo(params) {
    return http
      .get("/api/relatorios/pedidosporclientearquivo", { ...options, params })

      .then((response) => response.data);
  }

  imprimirListagemParticipantesRodada(params) {
    return http
      .get("/api/relatorios/listagemparticipantesrodada", {
        ...options,
        params,
      })

      .then((response) => response.data);
  }

  imprimirSomatorioPedidosClientesPorRepresentante(params) {
    return http
      .get("/api/relatorios/somatoriopedidosclientesporrepresentante", {
        ...options,
        params,
      })

      .then((response) => response.data);
  }
}

export default new ServiceRelatorios();
